import type { Action, ActionTPKDuelDataResponse } from './actions'
import type { DuelState, TPKState } from './types'
import { managePageAPIError } from 'shared/store/utils'
import endpoints from 'shared/store/endpoints'

export const makeDuelStateFromResponse = ({
    data,
    tpkToken
}: ActionTPKDuelDataResponse): DuelState => {
    const anySelected = data.childGain.selected || data.parentGain.selected
    return {
        tpkToken,
        email: data.email,
        childGain: {
            ...data.childGain,
            selected: anySelected ? data.childGain.selected : undefined,
            loaded: true
        },
        parentGain: {
            ...data.parentGain,
            selected: anySelected ? data.parentGain.selected : undefined,
            loaded: true
        },
        ...data
    }
}

export const initialState: TPKState = {
    duel: undefined,
    availability: -1
}

export const reducer = (
    state: TPKState = initialState,
    action: Action
): TPKState => {
    switch (action.type) {
        case 'TPK_DUEL_RESPONSE':
            return {
                ...state,
                duel: makeDuelStateFromResponse(action),
                error: undefined,
                networkError: undefined
            }

        case 'TPK_RESET_DUEL':
            return { ...state, duel: undefined }
        case 'TPK_ERROR':
            return { ...state, error: action.error }
        case 'TPK_PAGE_DATA_RESPONSE':
            return {
                ...state,
                error: undefined,
                networkError: undefined,
                pageData: { ...action.data }
            }
        case 'ALL_RESTAURANTS_DATA_RESPONSE':
            return {
                ...state,
                error: undefined,
                networkError: undefined,
                restaurantsData: action.data
            }
        case 'TPK_GOODIES_DATA_RESPONSE':
            return {
                ...state,
                error: undefined,
                networkError: undefined,
                goodies: action.data
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(
                state,
                action,
                endpoints.tuPreferesKing.pageData
            )
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        case 'AVAILABILITY_RESPONSE':
            return {
                ...state,
                availability: action.data,
                error: undefined
            }
        default:
            return state
    }
}
